import React from 'react';
import bem from 'utils/bem';
import { Skeleton } from '@mui/material';
import './index.sass';

const { block, el } = bem('youtube-teaser');
const YouTubeTeaser = ({ link }) => {
    return (
        <div className={block()}>
            <div className={ el('video') }>
                <iframe width="100%" height="auto" src={ link }
                        frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        iv_load_policy="3" modestbranding="1" showinfo="0" allowFullScreen rel="0"></iframe>
            </div>
        </div>
    )
}

export const YouTubeSkeletonTeaser = () => {
    return (
        <div className={block()}>
            <div className={ el('video') }>
                <Skeleton variant={'rectangular'} width={'100%'} height={'100%'} style={{position: 'absolute', top: 0, borderRadius: '10px'}}/>
            </div>
        </div>
    )
}

export default YouTubeTeaser;

